import { Injectable } from '@angular/core';
import * as angular from 'angular';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class ResultModel extends ModeModelBase {
  override _name = 'result';

  dataset: () => any;
  content: any;
  contentPromise: any;
  reportDataUrl: any;
  reportQueryUrl: any;
  oversized: boolean;
  csv: any;
  content_length: number;
  columns: any;

  override belongsTo = 'queryRun';
  override attributes = [
    { name: 'count', default: 0 },
    { name: 'content_length', default: 0 },
    { name: 'columns', default: null },
    { name: 'csv', default: '' },
  ];
  override initialize(resource) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    this.dataset = () => {
      if (self.content) {
        delete self.contentPromise;
        const deferred = this.injectables.$q.defer();
        deferred.resolve(self);
        return deferred.promise;
      } else if (self.contentPromise) {
        return self.contentPromise;
      } else {
        const deferred = this.injectables.$q.defer();
        self._resource
          .links('json')
          .$get()
          .then((response) => {
            if (response.config.longInt) {
              //handle long to string
              angular.forEach(response.data, (row) => {
                angular.forEach(self.columns, (col) => {
                  if (col.type === 'number' || col.type === 'integer') {
                    if (typeof row[col.name] === 'string') {
                      col.type = 'string';
                      this.injectables.logger.warn(
                        'Column "' + col.name + '" has integers too large to display; treating column as string'
                      );
                    }
                  }
                });
              });
            }
            self.content = response.data;
            deferred.resolve(self);
            delete self.contentPromise;
          })
          .catch((e) => {
            delete self.contentPromise;
            deferred.reject(e);
          });

        self.contentPromise = deferred.promise;
        return self.contentPromise;
      }
    };
    if (resource && resource.hasLink('web')) {
      this.reportDataUrl = resource.links('web').href;
    }
    if (resource && resource.hasLink('query_web')) {
      this.reportQueryUrl = resource.links('query_web').href;
    }
    if (!this.underBrowserSizeLimit()) {
      this.oversized = true;
      this.csv = resource.links('csv').href;
    }
  }
  underBrowserSizeLimit() {
    return this.content_length < 15728640;
  }
}

@Injectable({ providedIn: 'root' })
export class ResultModelAccessor extends ModelAccessorBase<ResultModel> {
  override name = 'result';
  override parentModel = 'queryRun';
  override parentIdAttribute = 'token';
  override createAttributes = [];
  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.result');
  }
  createModel(resource, opts?) {
    const model = new ResultModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
}
